import React from "react";
import { useParallax } from "../useParallax";

export default function Parallax(props: {
  scrollRef: React.RefObject<HTMLElement>;
  factor: number;
  children: React.ReactNode;
  effect: "translate" | "blur";
}) {
  const ref = React.useRef(null);

  useParallax({
    container: props.scrollRef,
    target: ref,
    factor: props.factor,
  });

  const calc = `calc(var(--scroll-offset) * ${props.factor})`;

  return (
    <div
      ref={ref}
      style={{
        transform: props.effect === "translate" ? `translateY(${calc})` : undefined,
        filter: props.effect === "blur" ? `blur(${calc})` : undefined,
      }}
    >
      {props.children}
    </div>
  );
}
